<template>
  <div v-if="!isLoading">
    <div class="row mx-0 mt-2 mb-3 justify-content-between">
      <div class="main-color-text bold-text"> {{ $t('operationLot.s.for.sale') }}</div>
      <div class="row mx-0 align-items-center">
        <div class="row mx-0 align-items-center">
          <b-link class="main-color-text bold-text mr-3" v-on:click="exportPdf()">
            {{ $t('operation.bilan.exporter') }}
            <file-download-icon size="18"/>
          </b-link>
          <b-link class="main-color-text bold-text mr-3" v-on:click="showCommercialisation()">
            {{ $t('Commercialisation') }}
            <home-dollar-icon size="18"/>
          </b-link>
          <b-link class="main-color-text bold-text ml-3" v-on:click="clickOnEditBtn()">
            {{ $t('Modify') }}
            <pencil-icon size="18"/>
          </b-link>
        </div>
      </div>
    </div>
    <div v-for="(lot, index) in lots" :key="index">
      <div class="card-lot my-2">
        <div v-if="lot.lotCoPro" class="d-flex align-items-center">
          <div class="main-red-color level-two-title bold-text">
          {{
            $t('OperationLot') + ' ' + lot.lotCoPro + ' - ' +
            lot.name + (lot.isLotVir ? ' (VIR)' : '')
          }}
          </div>
          <span v-if="lot.isLoue" class="badge-locataire">{{"En location"}}</span>
        </div>
        <div v-else class="d-flex align-items-center">
          <div class="main-red-color level-two-title bold-text">
            {{
              $t('OperationLot') + ' ' + lot.lotNumber + ' - ' +
              lot.name + (lot.isLotVir ? ' (VIR)' : '')
            }}
          </div>
          <span v-if="lot.isLoue" class="badge-locataire">{{"En location"}}</span>
        </div>
        <div class="row flex-row mx-0">
          <div class="col-md-6 row flex-row my-2">
            <div class="bold-text mr-2"> {{ $t('operationLot.PrixVenteTTC') + ' : ' }}</div>
            <span> {{ getPrixVenteTTC(lot) + ' (' + lot.prixParM2 + "€/m2)" }} </span>
          </div>

          <div class="col-md-6 row flex-row my-2">
            <div class="bold-text mr-2"> {{ $t('operationLot.Surface') + ' : ' }}</div>
            <span> {{ lot.surface }} m2 </span>
          </div>

          <div class="col-md-6 row flex-row my-2">
            <div class="bold-text mr-2"> {{ $t('operationLot.TypeLot') + ' : ' }}</div>
            <span> {{ $t(lot.typeLot.text) }} </span>
          </div>

          <div class="col-md-6 row flex-row my-2">
            <div class="bold-text mr-2"> {{ $t('operationLot.TypeTVA') + ' : ' }}</div>
            <span> {{ $t(lot.tva.tva) + ' ' + $t('and') + ' ' + $t(lot.tva.recuperable) }} </span>
          </div>
        </div>

        <div v-if="operationHaveBilan" class="row flex-row mx-0">
          <div class="col-md-6 row flex-row my-2">
            <div class="bold-text mr-2"> {{ $t('operationLot.Percentage.marge.global') + ' : ' }}</div>
            <span> {{
                (`${getPourcentageMargeGlobale(lot, lots)} %  → ${getMargeLot(lot, lots)}`)
              }} </span>
          </div>
          <div class="col-md-6 row flex-row my-2">
            <div class="bold-text mr-2"> {{ $t('operationLot.Part.prix.achat') + ' : ' }}</div>
            <span> {{ getPartPrixAchat(lot, lots) | formatEuro }} </span>
          </div>
        </div>
        <div class="row flex-row mx-0" v-if="lot.isLoue">
          <div class="col-md-6 row flex-row my-2">
            <div class="bold-text mr-2"> {{ $t('operationLot.nomLocataire') + ' : ' }}</div>
            <span v-if="lot.nomLocataire"> {{ lot.nomLocataire }} </span>
          </div>
          <div class="col-md-6 row flex-row my-2">
            <div class="bold-text mr-2"> {{ $t('operationLot.ActeVente') + ' : ' }}</div>
            <span v-if="lot.acteVente"> {{ lot.acteVente | formatDateReverse }} </span>
            <span v-if="lot.acteVente" class="ml-1">{{ `  (${lot.realDate ? 'date réelle' : 'date estimée'})` }}</span>
          </div>
        </div>

        <div class="row flex-row mx-0" v-else>
          <div class="col-md-6 row flex-row my-2">
            <div class="bold-text mr-2"> {{ $t('dataSourceInfo.Comment') + ' : ' }}</div>
            <span v-if="lot.comment !== 'null'"> {{ lot.comment }} </span>
          </div>
          <div class="col-md-6 row flex-row my-2">
            <div class="bold-text mr-2"> {{ $t('operationLot.ActeVente') + ' : ' }}</div>
            <span v-if="lot.acteVente"> {{ lot.acteVente | formatDateReverse }} </span>
            <span v-if="lot.acteVente" class="ml-1">{{ `  (${lot.realDate ? 'date réelle' : 'date estimée'})` }}</span>
          </div>
        </div>

        <div class="row flex-row mx-0" v-if="lot.isLoue">
          <div class="col-md-12 row flex-row my-2">
            <div class="bold-text mr-2"> {{ $t('dataSourceInfo.Comment') + ' : ' }}</div>
            <span v-if="lot.comment !== 'null'"> {{ lot.comment }} </span>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import api from "../../../services/api";

export default {
  name: "OperationShowInformations",

  components: {},

  props: {
    operationId: {
      default: null
    },
    currentSectionId: {
      default: null
    }
  },

  data() {
    return {
      isLoading: false,
      lots: [],
      operationBilanPrixHT: null,
      operationHaveBilan: null,
      margeNetteOperation: null,
    }
  },

  filters: {
    formatDateReverse: function (value) {
      if (!value) return 'N/A'
      return new Date(value).toLocaleDateString()
    }
  },

  async mounted() {
    this.isLoading = true
    await this.fetchData()
    await this.fetchOperationHaveBilan()
    if (this.operationHaveBilan) {
      await this.getChargeFonciere()
      await this.getMargeOperation()
    }
    this.isLoading = false
  },

  methods: {

    async fetchData() {
      await this.fetchLots()
    },

    async fetchLots() {
      await api
        .get(`/operationLot/getAllForOperation/${this.operationId}`)
        .then(response => {
          response.data.forEach(lot => {
            this.lots.push({
              id: lot.id,
              lotCoPro: lot.lotCoPro,
              name: lot.name,
              prixParM2: lot.prixParM2,
              prixVenteTTC: lot.prixVenteTTC,
              prixVenteHT: lot.prixVenteHT,
              comment: lot.comment,
              typeLot: lot.typeLot,
              surface: lot.surface,
              lotNumber: lot.lotNumber,
              tva: lot.tva,
              acteVente: lot.acteVente,
              realDate: lot.realDate,
              isLotVir: lot.isLotVir,
              isLoue: lot.isLoue,
              nomLocataire: lot.nomLocataire,
            })
          })
        })
    },

    async getChargeFonciere() {
      await api
        .get(`/operationBilan/getChargeFonciere/${this.operationId}`)
        .then(response => {
          this.operationBilanPrixHT = response.data.HT
        })
    },

    async getMargeOperation() {
      await api
        .get(`/operation/getMargeOperation/${this.operationId}`)
        .then(response => {
          this.margeNetteOperation = response.data.margeNette
        })
    },

    async fetchOperationHaveBilan() {
      await api
        .get(`operation/operationHaveBilan/${this.operationId}`)
        .then(response => {
          this.operationHaveBilan = response.data.bilan
        })
    },


    clickOnEditBtn() {
      this.$router.push({
        name: 'OperationLotsEdit',
        params: {
          operationId: this.operationId,
          currentSectionId: this.currentSectionId
        }
      })
    },

    showCommercialisation() {
      this.$router.push({
        name: 'CommercialisationLotsShow',
        params: {
          operationId: this.operationId,
          currentSectionId: this.currentSectionId
        }
      })
    },

    exportPdf() {
      // this.loadingPdf = true

      api.post(`/operationLot/downloadLotsPdf/${this.operationId}`, {}, {
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf'
        }
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Lots-${new Date().toLocaleDateString('fr-FR')}.pdf`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        // this.loadingPdf = false
      }).catch(() => {
        // this.loadingPdf = false
      })
    },

    getPourcentageMargeGlobale(lot, lots) {
      let prixVenteLot
      if (lot.tva.recuperable === "type.tva.enum.TVA_RECUPERABLE") {
        prixVenteLot = lot.prixVenteHT
      } else if (lot.tva.recuperable === "type.tva.enum.TVA_NON_RECUPERABLE") {
        prixVenteLot = lot.prixVenteTTC
      } else {
        prixVenteLot = lot.prixVenteTTC
      }

      let prixVenteTotal = lots.reduce(function (acc, obj) {
        let prixVente
        if (obj.tva.recuperable === "type.tva.enum.TVA_RECUPERABLE") {
          prixVente = obj.prixVenteHT
        } else if (obj.tva.recuperable === "type.tva.enum.TVA_NON_RECUPERABLE") {
          prixVente = obj.prixVenteTTC
        } else {
          prixVente = obj.prixVenteTTC
        }
        return acc + Number(prixVente);
      }, 0);
      return prixVenteTotal !== 0 ? ((prixVenteLot / prixVenteTotal) * 100).toFixed(2) : 0
    },

    getPartPrixAchat(lot, lots) {
      let percentage = this.getPourcentageMargeGlobale(lot, lots) / 100
      return (percentage * this.operationBilanPrixHT).toFixed(2)
    },

    getMargeLot(lot, lots) {
      let percentage = this.getPourcentageMargeGlobale(lot, lots) / 100
      const formatter = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
      });
      return formatter.format(percentage * this.margeNetteOperation);
    },

    getPrixVenteTTC(lot) {
      const formatter = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
      });
      return formatter.format(lot.prixVenteTTC);
    },
  }
}
</script>

<style scoped>

.card-lot {
  border: 2px solid var(--main-grey);
  padding: 15px;
}

.badge-locataire{
  display: flex;
  border-radius: 14px;
  padding: 2px 6px;
  background:  #009DFF;
  margin-left: 1em;
  color: #FFFFFF;
}

</style>



// WEBPACK FOOTER //
// src/views/operation/OperationShowTabs/OperationShowInformations.vue